<template>
  <div class="inline-flex rounded-lg bg-primary-50 p-1 h-11 w-full">
    <div
      v-for="option in options"
      :key="option.value"
      @click="$emit('option-click', option.value)"
      :class="[
        'flex-1 text-center cursor-pointer box-border py-2 text-sm text-secondary-100 rounded-lg font-normal transition-all duration-200 focus:outline-none',
        (selectedValue || defaultValue) === option.value
          ? 'bg-base-0 text-gray-900 shadow-sm font-bold'
          : ''
      ]"
      :aria-pressed="(selectedValue || defaultValue) === option.value"
    >
      {{ option.label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultiStateSwitch',
  props: {
    options: {
      type: Array,
      required: true,
    },
    selectedValue: {
      type: String,
      default: null, // Allows selectedValue to be optional
    },
    defaultValue: {
      type: String,
      default: null, // Optional default value for when no selectedValue is provided
    },
  },
}
</script>
